import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import "./MenuPage.scss";
import { useHistory, useLocation, useParams } from "react-router";
import { useSelector } from "react-redux";
import SearchBar from "../../components/SearchBar/SearchBar";
import SidebarMenu from "../../components/SidebarMenu/SidebarMenu";
import { ReactComponent as BurgerIcon } from "../../common/assets/svg/burgerIcon.svg";
import { RestaurantMenuItem } from "../../common/features/restaurant/restaurantModels";
import NoResultsFound from "../../common/assets/svg/noItemFound.svg";
import logo from "../../common/assets/svg/Powered By.svg";
import ItemCardMobile from "../../components/itemCardMobile/itemCardMobile";
import SpecialMenu from "../../components/SpecialMenu/SpecialMenu";
import searchiconImage from "../../common/assets/svg/search-icon.svg";
import fullfilter from "../../common/assets/svg/Fullfilter.svg";
import { useDispatch } from "react-redux";
import { requestCheckOffers } from "../../common/features/offers/offerActions";
import CustomerInfoPopup from "../../components/CustomerInfoPopup/index";
import {
  getRestaurantDetails,
  getRestaurantMenuDetails,
} from "../../common/features/restaurant/restaurantAction";
// import { p } from "react-router/dist/development/fog-of-war-CGNKxM4z";
import cancelIcon from "../../common/assets/svg/cancel.svg";
import {
  cleanupScheduler,
  initializeScheduler,
} from "../../helper/schedulerHelperv1";
import Gridicon from "../../common/assets/svg/grid.svg";
import listicon from "../../common/assets/svg/listviewicon.svg";
import Loading from "components/Loading";

interface RenderDishCardProps {
  menuDetail: RestaurantMenuItem;
  ItemUpdate(itemId: string, quantity: string): void;
}
interface IAddressDetail {
  addressLine1: string;
  apartment: string;
  state: string;
  city: string;
  zipcode: string;
  addressTag: string;
  deliveryInstructions: string;
}
const quickfilers = ["Currently Available", "Strictly Veg", "Jain"];

const amount = 217.86;
const addresses = [
  {
    id: "1",
    type: "Home",
    streetAddress: "123 Maple Avenue",
    aptNumber: "Apt 5C",
    city: "New York",
    zipCode: "10001",
  },
  // Add more addresses as needed
];
const MenuPage = () => {
  const dispatch = useDispatch();
  const cartData = useSelector((state: any) => state.cart.cart);
  const location = useLocation();
  const touchStartRef = useRef({ x: 0, y: 0 });
  const sidebarRef = useRef<HTMLDivElement | null>(null);
  let { merchantType, merchantSlug, menuType, orderId, tableId, eventDate } =
    useParams<any>();
  const [showQuickfilter, setShowQuickfilter] = useState(false);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [SearchResults, setSearchResults] = useState(false);
  const [switchingOrderType, setSwitchingOrderType] = useState(false);
  const [signupPopup, setSignupPopup] = useState(false);
  const [cardDelete, setCardDelete] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(false);
  const [showMenuCategories, setshowMenuCategories] = useState(false);
  const [isCustomerInfoPopupOpen, setIsCustomerInfoPopupOpen] = useState(false);
  const [deliveryDetails, setDeliveryDetails] = useState<boolean>(false);
  const [selectedAddress, setSelectedAddress] = useState<any>({});
  const [deliveryForm, setDeliveryForm] = useState<boolean>(false);
  const [selectedAddressId, setSelectedAddressId] = useState("1");
  const [isHovered, setIsHovered] = useState(false);

  // const [status, setStatus] = useState<"loading" | "success" | "error">(
  //   "loading"
  // );

  const categoryMTypes = useSelector(
    (state: any) => state.restaurant.categoryMTypes
  );
  const subCategoryMTypes = useSelector(
    (state: any) => state.restaurant.subCategoryMTypes
  );

  const restaurantDetails = useSelector(
    (state: any) => state.restaurant.currentRestaurantDetail
  );

  const restaurantMenuCategories = useSelector(
    (state: any) => state.restaurant.restaurantMenuCategories
  );

  const restaurantMenuDetails: Array<RestaurantMenuItem> = useSelector(
    (state: any) => state.restaurant.restaurantMenuDetails
  );
  const restaurantDetailLoading = useSelector(
    (state: any) => state.restaurant.restaurantDetailLoading
  );

  const restaurantMenuDetailLoading = useSelector(
    (state: any) => state.restaurant.restaurantMenuDetailLoading
  );
  const restaurantMenuDetailSuccess = useSelector(
    (state: any) => state.restaurant.restaurantMenuSuccess
  );
  const verifyOtpLoading = useSelector(
    (state: any) => state.auth.verifyOtpLoading
  );

  const currentOrderType = useSelector(
    (state: any) => state.restaurant.currentOrderTypeid
  );
  const currentMenuType = useSelector(
    (state: any) => state.restaurant.currentMenuType
  );

  const selectedDeliveryAddress = useSelector(
    (state: any) => state?.restaurant?.selectedDeliveryAddress
  );

  const [DeliveryAddress, setselectedDeliveryAddress] = useState<any>([]);

  const currentSelectedOrderType = useSelector(
    (state: any) => state.cart?.currentOrderType
  );

  const addedTip = useSelector((state: any) => state.cart.tipValue);

  // const orderTypeName = restaurantDetails?.orderTypes?.find(
  //   (o: any) => o?.id === currentOrderType
  // )?.typeName;

  const isMobile = window.innerWidth <= 500 || menuType == "DineIn";

  // useEffect(() => {
  //   if (!["Pickup", "Delivery"].includes(menuType || "")) {
  //     //TODO: Remove this once other flows are done
  //     history.push("/notFound");
  //   }
  //   if (menuType) {
  //     setSwitchingOrderType(true);
  //   }
  // }, [menuType]);

  const [dishes, setDishes] = useState<RestaurantMenuItem[]>([]);
  const UserId = localStorage.getItem("USER_ID");
  const history = useHistory();
  const [searchedItem, setSearchedItem] = useState("");
  const [specialDishes, specialSetDishes] = useState<RestaurantMenuItem[]>([]);
  const [customisationItemId, setCustomisationItemId] = useState("");
  const [activeCategory, setActiveCategory] =
    useState<string>("Today's Exclusive");

  const [locationShow, setLocationShow] = useState<boolean>(true);
  const [currentOrdertypeDetails, setCurrentOrdertypeDetails] = useState<any>();

  // const [addresses, setAddresses] = useState<IAddressDetail[]>([]);
  // const [address, setAddress] = useState<IAddressDetail>({
  //   addressLine1: "",
  //   apartment: "",
  //   state: "",
  //   city: "",
  //   zipcode: "",
  //   addressTag: "",
  //   deliveryInstructions: "",
  // });

  const restaurantMenu = useMemo(() => {
    return restaurantMenuDetails;
  }, [restaurantMenuDetails]);

  const menuItemDisplayFilter = useCallback((menuItem: RestaurantMenuItem) => {
    return menuItem.display == 1;
  }, []);

  const getMenuItemImageUrl = useCallback(
    (imgId: string | null, ext: string | null) => {
      return process.env.REACT_APP_IMAGE_URL + "img" + "/" + imgId + "." + ext;
    },
    []
  );

  useEffect(() => {
    // console.log('Initializing scheduler in MenuPage');
    initializeScheduler();
   
    // Cleanup scheduler when component unmounts
    if (selectedDeliveryAddress?.id) {
      setSelectedAddressId(selectedDeliveryAddress?.id);
    }
    return () => {
      // console.log('Cleaning up scheduler in MenuPage');
      cleanupScheduler();
    };
  }, [restaurantDetails, restaurantMenuDetails, restaurantDetailLoading]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target as Node)
      ) {
        setshowMenuCategories(false);
      }
    };
    if (showMenuCategories) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMenuCategories]);

  // const handleDeliveryFormSubmit = (formData: any) => {
  //   setAddresses((prev) => [...prev, { ...formData }]);
  // };
  // const handleAddressFieldOnChange = (e: any) => {
  //   setAddress((prev) => ({
  //     ...prev,
  //     [e.target.name]: e.target.value,
  //   }));
  // };
  const [showGrid, setShowGrid] = useState(false);

  useEffect(() => {
    const GetView = localStorage.getItem("View");
    if (GetView === "Grid") {
      setShowGrid(true);
    } else {
      setShowGrid(false);
    }
  }, []);

  // Add new effect to handle search state changes
  useEffect(() => {
    if (!isSearchActive) {
      // Reset to default state when search is deactivated
      setActiveCategory("Today's Exclusive");
      if (restaurantMenu && restaurantMenu.length > 0) {
        setDishes([...restaurantMenu]);
      }
      // Scroll to top of the menu
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [isSearchActive, restaurantMenu]);

  const RenderDishCardNew = useCallback(
    (data: RenderDishCardProps) => {
      return (
        <div className={`restore`}>
          {isMobile ? (
            <ItemCardMobile
              GridView={showGrid}
              data={data.menuDetail}
              setCustomisationItemId={setCustomisationItemId}
              isRestaurantOpen={restaurantDetails.open}
            />
          ) : null}
        </div>
      );
    },
    [restaurantDetails, isSearchActive, searchedItem, dishes, showGrid]
  );

  const handleSearch = (query: string) => {
    if (restaurantMenu && restaurantMenu.length > 0) {
      const tempDishData = restaurantMenu.filter((item) =>
        item?.itemName?.toLowerCase()?.includes(query?.toLowerCase())
      );

      setDishes(tempDishData);
      setSearchResults(tempDishData.length === 0);
    }
  };

  const handleFilterClick = () => {
    setShowQuickfilter(true);
  };

  const handleItemClick = (item: any) => {};

  function ItemUpdate(itemId: string, quantity: string) {}

  const customerId = localStorage.getItem("USER_ID");

  // useEffect(() => {
  //   if (customerId) {
  //     dispatch(viewDeliveryAddressRequest());
  //   }
  // }, []);

  useEffect(() => {
    const [navigationEntry] = performance.getEntriesByType(
      "navigation"
    ) as PerformanceNavigationTiming[];

    if (navigationEntry?.type === "reload") {
      setIsCustomerInfoPopupOpen(true);
    }
  }, []);

  const categoryRefs = useRef<Record<string, HTMLDivElement | null>>({});
  const subCategoryRefs = useRef<Record<string, HTMLDivElement | null>>({});
  const categoryContainerRef = useRef<HTMLDivElement | null>(null);

  // Initialize refs
  useEffect(() => {
    restaurantMenuCategories.forEach((category: any) => {
      if (!categoryRefs.current[category]) {
        categoryRefs.current[category] = null;
      }
    });
    // console.log(categoryRefs.current, "Heres is the red");
  }, [restaurantMenuCategories]);

  const [isVisible, setIsVisible] = useState(true);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  // const [selected, setSelected] = useState("Pickup");

  const handleTouchStart = (event: any) => {
    const touch = event.touches[0];
    touchStartRef.current = {
      x: touch.clientX - position.x,
      y: touch.clientY - position.y,
    };
    // setPosition({ x: touch.clientX, y: touch.clientY });
    setIsDragging(true);
  };

  const handleTouchMove = (event: any) => {
    if (!isDragging) return;
    const touch = event.touches[0];
    const newX = touch.clientX - touchStartRef.current.x;
    const newY = touch.clientY - touchStartRef.current.y;
    setPosition({ x: newX, y: newY });
  };

  const handleTouchEnd = (e: React.TouchEvent<HTMLDivElement>) => {
    const touch = e.changedTouches[0];
    const elements = document.elementsFromPoint(touch.clientX, touch.clientY);
    const dropTarget = elements.find((el) => el.classList.contains("dropzone"));
    if (dropTarget) {
      setIsVisible(false);
    }
    setIsDragging(false);
  };

  const handleDrop = (event: any) => {
    // event.preventDefault();
    // setIsVisible(false);
    setIsDragging(false);
  };

  const handleDragOver = (event: any) => {
    // event.preventDefault();
    // setIsVisible(false);
    setIsHovered(true);
  };

  const scrollToCategory = (category: string) => {
    const element = categoryRefs.current[category];
    if (element) {
      // Get the parent container that has the scroll
      const container = document.querySelector('.New-Menu-container, .New-Menu-Container-withFooter');
      if (container) {
        // Calculate the position to scroll to
        const containerRect = container.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();
        const scrollTop = elementRect.top - containerRect.top + container.scrollTop;
        
        // Smooth scroll the container to the element
        container.scrollTo({
          top: scrollTop,
          behavior: 'smooth'
        });
      }
    }
   // setActiveCategory(category);
  };

  const scrollToSubCategory = (subCategory: string) => {
    const element = subCategoryRefs.current[subCategory];

    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const dependecy = restaurantMenuCategories
    .map((c: any) => categoryRefs.current[c])
    .join();

  useEffect(() => {
    // Reset observer when search is active
    if (isSearchActive) {
      return;
    }

    const debounceTime = 2; // milliseconds
    let debounceTimer: ReturnType<typeof setTimeout> | null = null;

    const debouncedUpdateCategory = (category: string) => {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        if (activeCategory !== category) {
          setActiveCategory(category);

          // Smooth scroll the category into view, but only if it's not already visible
          if (categoryContainerRef.current) {
            const categoryElement = categoryContainerRef.current.querySelector(
              `[id="${category}"]`
            ) as HTMLElement | null;

            if (categoryElement) {
              const containerRect =
                categoryContainerRef.current.getBoundingClientRect();
              const elementRect = categoryElement.getBoundingClientRect();

              // Only scroll if element is outside of view
              if (
                elementRect.left < containerRect.left ||
                elementRect.right > containerRect.right
              ) {
                categoryElement.scrollIntoView({
                  behavior: "smooth",
                  block: "nearest",
                  inline: "center",
                });
              }
            }
          }
        }
      }, debounceTime);
    };

    const elements = Object.values(categoryRefs.current).filter(Boolean);
    if (elements.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        // Find the category with the highest intersection ratio (most visible)
        const mostVisibleEntry = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (mostVisibleEntry) {
          const category =
            mostVisibleEntry.target.getAttribute("data-category");
          if (category) {
            debouncedUpdateCategory(category);
          }
        }
      },
      {
        root: null,
        threshold: [0.1, 0.3, 0.45, 0.5],
        // Adjust rootMargin to prioritize content near the top of the screen
        rootMargin: "-20px 0px 0% 0px",
      }
    );

    elements.forEach((el: any) => observer.observe(el));

    Object.values(categoryRefs.current).forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      observer.disconnect();
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
    };
  }, [restaurantMenuCategories, dependecy, activeCategory, isSearchActive]); // Added isSearchActive to dependencies

  const targetCategory = "Soups".toLowerCase();

  const filteredItems = dishes.filter(
    (item) => item.category && item.category.toLowerCase() === targetCategory
  );
  const handleLogout = () => {
    localStorage.removeItem("USER_ID");
    // dispatch(removeauthInfo())
  };
  const onDeleteAddress = (id: any) => {
    // setAddresses((prev) => prev.filter((value, idx) => idx !== index));
    if (selectedAddress == id) {
      setSelectedAddress("");
    }
  };
  const [isPageRefreshed, setIsPageRefreshed] = useState(false);

  useEffect(() => {
    const isRefreshed = sessionStorage.getItem("hasrefreshed");

    if (!isRefreshed) {
      setIsPageRefreshed(true);
      sessionStorage.setItem("hasrefreshed", "true");
    }

    window.addEventListener("beforeunload", () => {
      sessionStorage.removeItem("hasrefreshed");
    });

    return () => {
      window.removeEventListener("beforeunload", () => {
        sessionStorage.removeItem("hasrefreshed");
      });
    };
  }, []);

  const onAddressSelect = (addressId: string) => {
    setSelectedAddress(addressId);
  };

  const getImageURL = useCallback(
    (type: string) => {
      if (restaurantDetails && restaurantDetails.media.length > 0) {
        const logoMedia =
          restaurantDetails &&
          restaurantDetails.media.filter(
            (media: any) => media.entityType == type
          )[0];

        return (
          process.env.REACT_APP_IMAGE_URL +
          logoMedia.mimeType.split("/")[0] +
          "/" +
          logoMedia.id +
          "." +
          logoMedia.mimeType.split("/")[1]
        );
      } else {
        return "";
      }
    },
    [restaurantDetails]
  );

  // TODO: handle- no data state properly
  if (
    restaurantDetailLoading ||
    restaurantMenuDetailLoading ||
    verifyOtpLoading
  ) {
    return <Loading type="pageLoad" />;
  }

  return (
      <div id="merchant-home-page-container-new">
        <div className="dine-screen-header">
          <img src={getImageURL("LOGO")} alt="" className="merchant-logo" />
        </div>

        <div className="New-MenuPage-Container mobile">
          {!showQuickfilter &&
            locationShow &&
            UserId &&
            currentSelectedOrderType?.toLowerCase() === "delivery" && (
              <p
                className="location-text-new-container"
                // onClick={() => setDeliveryForm(true)}
              >
                <span>
                  {/* <Locationicon
                    className="location-icon-new"
                    // onClick={() => setDeliveryForm(true)}
                  /> */}
                </span>
                <span
                  className="location-text-new-type"
                  // onClick={() => setDeliveryForm(true)}
                >
                  {/* {selectedAddress.addressTag},{"  "} */}
                </span>
                <span
                  className="location-text-new"
                  onClick={() => setDeliveryDetails(true)}
                >
                  {DeliveryAddress?.addressLine1 ? (
                    <>
                      {/* {selectedAddress.addressLine1}.{selectedAddress.state},
                  {selectedAddress.city}
                  {selectedAddress.zipcode}. */}
                      <span className="fw-700">{DeliveryAddress?.tag}</span>
                      {DeliveryAddress?.apartment
                        ? ` ${DeliveryAddress?.apartment},`
                        : ""}
                      {DeliveryAddress?.addressLine1
                        ? `${DeliveryAddress?.addressLine1},`
                        : ""}
                      {DeliveryAddress?.city ? `${DeliveryAddress?.city},` : ""}
                      {DeliveryAddress?.state
                        ? `${DeliveryAddress?.state},`
                        : ""}
                      {DeliveryAddress?.zipcode
                        ? `${DeliveryAddress?.zipcode}.`
                        : ""}
                    </>
                  ) : (
                    "Select Delivery Address"
                  )}
                </span>
              </p>
            )}
        </div>
        <div
          className="New-MenuPage-Container mobile"
          style={{ position: "sticky", top: "0px", zIndex: 1 }}
        >
          {!showQuickfilter && (
            <div>
              <SearchBar
                items={dishes}
                onSearch={handleSearch}
                searchIcon={searchiconImage}
                onFilterClick={handleFilterClick}
                onItemClick={handleItemClick}
                setIsSearchActive={(active) => {
                  setIsSearchActive(active);
                  if (!active) {
                    setSearchedItem("");
                    setSearchResults(false);
                  }
                }}
                showGrid={showGrid}
                setShowGrid={setShowGrid}
                setSearchResults={setSearchResults}
                isSearchActive={isSearchActive}
                setSearchedItem={setSearchedItem}
                setDishes={setDishes}
              />
            </div>
          )}
          {!isSearchActive ? (
            <div className="categoryfilter-container-mobile">
              {!showMenuCategories && (
                <BurgerIcon
                  className="category-filter-icon"
                  // onClick={()=>navigate("/OrderTracking")}
                  onClick={() => setshowMenuCategories((prev) => !prev)}
                  // onClick={() => setDeliveryDetails(true)}
                />
              )}
              <div
                className="categories-list-mobile-new-scroll"
                ref={categoryContainerRef}
                style={{
                  display: "flex",
                  overflowX: "auto",
                }}
              >
                {/* <div
                        className={`categoryfilter-button-container ${
                          activeCategory === "Today's Exclusive"
                            ? "activecategory"
                            : ""
                        }`}
                        onClick={() => {
                          setActiveCategory("Today's Exclusive");
                          categoryRefs.current[
                            "Today's Exclusive"
                          ]?.scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                          });
                        }}
                      >
                        <span className="categoryfilter-button">
                          Today's Exclusive
                        </span>
                      </div> */}

                {restaurantMenuCategories
                  .filter((category: any) =>
                    dishes.some(
                      (item) =>
                        (item.category &&
                          item.category.toLowerCase() ===
                            category.toLowerCase()) ||
                        item?.subCategory?.toLowerCase() ===
                          category.toLowerCase()
                    )
                  )
                  .map(
                    (category: any, index: number) =>
                      category != "" &&
                      category != null && (
                        <div
                          key={index}
                          className={`categoryfilter-button-container ${
                            activeCategory === category ? "activecategory" : ""
                          }`}
                          onClick={() => scrollToCategory(category)}
                          style={{
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                          }}
                          id={category}
                        >
                          <span className="categoryfilter-button">
                            {category} ({categoryMTypes[category]?.quantity})
                          </span>
                        </div>
                      )
                  )}
              </div>
            </div>
          ) : null}

            <div className="sideMenu-wrapper">
              {showMenuCategories && (
                <SidebarMenu
                  setshowMenuCategories={setshowMenuCategories}
                  categoryMTypes={categoryMTypes}
                  scrollToCategory={scrollToCategory}
                  scrollToSubCategory={scrollToSubCategory}
                  ref={sidebarRef}
                />
              )}
            </div>
        </div>

        <div className="no-search-text">
          {!showQuickfilter && (
            <>
              {isSearchActive ? (
                <>
                  {SearchResults && (
                    <div className="search-not-found-container">
                      <img src={NoResultsFound} alt="" />
                      <span className="search-not-found-text1">
                        Search not found?{" "}
                      </span>
                      <span className="search-not-found-text2">
                        Try something else.
                      </span>
                    </div>
                  )}
                </>
              ) : (
                <>
                  {/* <div className="quickfilter-container-mobile">
                    {quickfilers.map((item, index) => (
                      <div className="quickfilter-button-container" key={index}>
                        <button key={index} className="quickfilter-button">
                          {item}
                        </button>
                        <span>
                          <Toggle toggle={true} />
                        </span>
                      </div>
                    ))}
                  </div> */}

                  <div
                    className={
                      cartData?.items?.length > 0
                        ? "New-Menu-Container-withFooter"
                        : "New-Menu-container"
                    }
                  >
                    {restaurantMenuCategories
                      .filter((category: any) =>
                        dishes
                          ?.filter(menuItemDisplayFilter)
                          .some(
                            (item) =>
                              item.category === category ||
                              item.subCategory === category
                          )
                      )
                      .map((category: any) => {
                        // Group items by subcategory
                        const itemsBySubcategory = dishes
                          ?.filter(menuItemDisplayFilter)
                          .filter((item) => item.category === category)
                          .reduce((acc: Record<string, any[]>, item) => {
                            const subcategory = item.subCategory || "";
                            if (!acc[subcategory]) {
                              acc[subcategory] = [];
                            }
                            acc[subcategory].push(item);
                            return acc;
                          }, {});

                        const itemsByCategory = dishes
                          ?.filter(menuItemDisplayFilter)
                          .filter(
                            (item) =>
                              item?.category == null &&
                              item?.subCategory === category &&
                              item?.category !== "" &&
                              item?.subCategory !== ""
                          )
                          .reduce((acc: Record<string, any[]>, item) => {
                            const categories =
                              item?.category == null &&
                              item?.subCategory === category
                                ? item?.subCategory
                                : item?.category || "";
                            if (!acc[categories]) {
                              acc[categories] = [];
                            }
                            acc[categories]?.push(item);
                            return acc;
                          }, {});

                        return (
                          <>
                            {(Object.entries(itemsBySubcategory)?.length > 0 ||
                              Object.entries(itemsByCategory).length > 0) && (
                              <div
                                key={category}
                                ref={(el) => {
                                  if (el && category) {
                                    categoryRefs.current[category] = el;
                                  }
                                }}
                                data-category={category}
                                className="category-section"
                              >
                                {/* <h2 className="category-name-new-mobile">{category}</h2> */}

                                <div className="menu-items-container-mobile">
                                  {Object.entries(itemsBySubcategory)?.length >
                                    0 &&
                                    Object.entries(itemsBySubcategory).map(
                                      ([subcategory, items]) => (
                                        <div
                                          key={subcategory}
                                          className="subcategory-section"
                                        >
                                          <h3
                                            className="subcategory-name-new-mobile"
                                            ref={(el) => {
                                              subCategoryRefs.current[
                                                subcategory
                                              ] = el;
                                            }}
                                          >
                                            {subcategory} (
                                            {subCategoryMTypes[subcategory]
                                              ?.quantity > 0 &&
                                              subCategoryMTypes[subcategory]
                                                ?.quantity}
                                            )
                                          </h3>
                                          <div className="subcategory-items">
                                            {items?.map((menuDetail) => (
                                              <RenderDishCardNew
                                                key={menuDetail.itemId}
                                                menuDetail={menuDetail}
                                                ItemUpdate={ItemUpdate}
                                              />
                                            ))}
                                          </div>
                                        </div>
                                      )
                                    )}
                                </div>

                                <div className="menu-items-container-mobile">
                                  {Object.entries(itemsByCategory).length > 0 &&
                                    Object.entries(itemsByCategory).map(
                                      ([category, items]) => (
                                        <div
                                          key={category}
                                          className="subcategory-section"
                                        >
                                          <h3 className="subcategory-name-new-mobile">
                                            {category} (
                                            {itemsByCategory[category]
                                              ?.length || ""}
                                            )
                                          </h3>
                                          <div className="subcategory-items">
                                            {items?.map((menuDetail) => (
                                              <RenderDishCardNew
                                                key={menuDetail.itemId}
                                                menuDetail={menuDetail}
                                                ItemUpdate={ItemUpdate}
                                              />
                                            ))}
                                          </div>
                                        </div>
                                      )
                                    )}
                                </div>
                              </div>
                            )}
                          </>
                        );
                      })}
                    {/* <div className="footerLogo">
                      <img src={logo} alt="" />
                    </div> */}
                  </div>
                </>
              )}
            </>
          )}

          {isSearchActive && searchedItem.length > 0 && (
            <>
              <div className="menu-items-container-mobile-one">
                {dishes
                  ?.filter(menuItemDisplayFilter)
                  .map((menuDetail: RestaurantMenuItem, index) => {
                    return (
                      <RenderDishCardNew
                        menuDetail={menuDetail}
                        key={menuDetail.itemId}
                        ItemUpdate={ItemUpdate}
                      />
                    );
                  })}
              </div>
              <div className="footerLogoSearch">
                <img src={logo} alt="" />
              </div>
            </>
          )}

          {!isCustomerInfoPopupOpen &&
            !isSearchActive &&
            !showQuickfilter &&
            isVisible && (
              <div
                draggable
                onDragStart={handleTouchStart} // Desktop
                onTouchStart={handleTouchStart} // Mobile
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
                style={{
                  position: "absolute",
                  left: position.x,
                  top: position.y,
                  cursor: "grab",
                  touchAction: "none",
                  zIndex: 10,
                }}
                // style={{
                //   cursor: "grab",
                //   touchAction: "none",
                //   // left: `${position.x}px`,
                //   // top: `${position.y}px`,
                // }}
                onClick={(e) => {
                  // e.stopPropagation();
                  setIsCustomerInfoPopupOpen(true);
                }}
              ></div>
            )}

          {isDragging && (
            <div className="canelicon-overLay1">
              <div className="canelicon-overLay2">
                <img
                  onDrop={handleDrop}
                  onDragOver={handleDragOver}
                  onTouchMove={() => setIsDragging(false)}
                  onMouseOver={() => setIsDragging(false)}
                  onClick={() => setIsDragging(false)}
                  onTouchStart={() => setIsHovered(true)}
                  onTouchEnd={() => {
                    setIsVisible(false);
                    setIsHovered(false);
                  }}
                  src={cancelIcon}
                  alt=""
                  className={isHovered ? "dropzone hovered" : "dropzone"}
                />
              </div>
            </div>
          )}

          {/* {signupPopup && <Signupnew isOpen={signupPopup} onClose={() => { setSignupPopup(false) }} />} */}

          {/* {showQuickfilter && (
            <Fullfilter setShowQuickfilters={setShowQuickfilter} />
          )} */}
        </div>
      </div>
  );
};

export default MenuPage;
